import { observer } from 'mobx-react-lite'
import { RowContent } from 'components/ModalsContainer/v1Modals/PatientSummary/common'

import Rxs from 'models/Provider/visits/PendingVisit/Rxs'

const verticalRows = [
  {
    label: 'medication',
    fieldName: 'name',
  },
  {
    label: 'directions',
    fieldName: 'directions',
  },
  {
    label: 'pharmacy notes',
    fieldName: 'pharmacyNotes',
  },
]

const horizontalRowItems = [
  {
    label: 'quantity',
    fieldName: 'quantity',
  },
  {
    label: 'refills',
    fieldName: 'refills',
  },
  {
    label: 'unit',
    fieldName: 'totalUnit',
  },
  {
    label: 'days supply',
    fieldName: 'daysSupply',
  },
]

type MedicationsProps = {
  rxs: Rxs
}

const Medications = ({ rxs }: MedicationsProps) => {
  if (!rxs.length) {
    return null
  }

  return (
    <>
      <h6 className="typography-body-xl text-primary-800 font-medium mb-4">Medications</h6>

      <div className="flex flex-col gap-3">
        {rxs.map((medication) => {
          return (
            <div key={medication.id} className="min-w-[25.71em] p-6 border border-neutral-300/50">
              {verticalRows.map(({ label, fieldName }) =>
                medication[fieldName] ? (
                  <RowContent label={label} content={medication[fieldName]} className="mb-6" key={label} />
                ) : null,
              )}

              <div className="flex flex-wrap">
                {horizontalRowItems.map(({ label, fieldName }) => (
                  <RowContent
                    label={label}
                    content={`${medication[fieldName] || 0}`}
                    key={label}
                    className="mr-3 mb-2"
                  />
                ))}
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default observer(Medications)
